import React, { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

// Test component to verify question types are working
const QUESTION_TYPES = [
  { value: 'MCQ_SINGLE_CORRECT', label: 'MCQ Single Correct' },
  { value: 'MCQ_MULTIPLE_CORRECT', label: 'MCQ Multiple Correct' },
  { value: 'TRUE_FALSE', label: 'True/False' },
  { value: 'FILL_IN_THE_BLANK_NUMERIC', label: 'Fill in the Blank (Numeric)' },
  { value: 'ESSAY', label: 'Essay' },
  { value: 'MATCHING', label: 'Matching' },
];

export const QuestionTypeTest: React.FC = () => {
  const [selectedType, setSelectedType] = useState<string>('');

  return (
    <div className="p-6 border rounded-lg bg-white shadow-sm">
      <h3 className="text-lg font-semibold mb-4">Question Type Test</h3>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2">Select Question Type:</label>
          <Select value={selectedType} onValueChange={setSelectedType}>
            <SelectTrigger className="w-full">
              <SelectValue placeholder="Choose a question type..." />
            </SelectTrigger>
            <SelectContent>
              {QUESTION_TYPES.map(type => (
                <SelectItem key={type.value} value={type.value}>
                  {type.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        {selectedType && (
          <div className="p-4 bg-gray-50 rounded-lg">
            <h4 className="font-medium mb-2">Selected Type:</h4>
            <p className="text-sm text-gray-600">Value: <code>{selectedType}</code></p>
            <p className="text-sm text-gray-600">
              Label: <code>{QUESTION_TYPES.find(t => t.value === selectedType)?.label}</code>
            </p>
            
            {selectedType === 'ESSAY' && (
              <div className="mt-3 p-3 bg-blue-50 rounded border-l-4 border-blue-400">
                <p className="text-sm text-blue-700">✅ Essay question type is working!</p>
              </div>
            )}
            
            {selectedType === 'MATCHING' && (
              <div className="mt-3 p-3 bg-green-50 rounded border-l-4 border-green-400">
                <p className="text-sm text-green-700">✅ Matching question type is working!</p>
              </div>
            )}
          </div>
        )}

        <div className="text-xs text-gray-500">
          <p>Available question types: {QUESTION_TYPES.length}</p>
          <p>New types added: ESSAY, MATCHING</p>
        </div>
      </div>
    </div>
  );
};
